import React, { DispatchWithoutAction, FC, MouseEvent } from 'react';

import { deleteIcon, edit } from 'assets/icons';
import { SvgWrapper } from 'components/atoms/svg-wrapper';

import styles from './styles.module.css';

interface ITableActionsCellProps {
  onEdit?: DispatchWithoutAction;
  onDelete?: DispatchWithoutAction;
}

export const TableActionsCell: FC<ITableActionsCellProps> = ({ onEdit, onDelete }) => {
  const onCellClick = (event: MouseEvent) => {
    event.stopPropagation();
  };

  return (
    <div className={styles.cell} onClick={onCellClick}>
      {!!onEdit && <SvgWrapper width={17.9} height={17.7} details={edit} onClick={onEdit} />}
      {!!onDelete && <SvgWrapper width={21.9} height={21.9} details={deleteIcon} onClick={onDelete} />}
    </div>
  );
};
